var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress",class:_vm.progressColor},[_c('span',{staticClass:"progress-meter",style:({ width: _vm.percentageString })},[_c('p',{staticClass:"progress-meter-text"},[_vm._v(" "+_vm._s(_vm.percentage > 0 ? _vm.percentageString : "")+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }